var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.item)?_c('tr',[_vm._m(0),_c('td',[_vm._v(_vm._s(_vm.item.sent))]),_c('td',[_vm._v(_vm._s(_vm.item.delivered))]),_c('td',[_vm._v(_vm._s(_vm.item.accepted))]),_c('td',[_vm._v(_vm._s(_vm.item.opened))]),_c('td',[_vm._v(_vm._s(_vm.item.bounced))]),_c('td',[_vm._v(_vm._s(_vm.item.blocked))])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('td',[_c('b',[_vm._v("TOTAL")])])
}]

export { render, staticRenderFns }